<div class="sidenav-content" cdkScrollable *ngIf="!isLoading else spinner">
	<copo-panel-header [isBackButtonVisible]="true" (backButtonClick)="goBack()" [titleHeaderText]="('auction.selection'|translate)+'-'+('auction.bidding'|translate)+' '+auctionOffer.name">
		<button mat-flat-button type="button" color="primary" (click)="goToSummary($event)">
			<span translate>issue.select.batches.action.next</span>
		</button>
	</copo-panel-header>
	<div class="offer-time-counter-container">
		<div class="offer-time-counter">
			<mat-icon class="customize-time-ends-icon" svgIcon="times_ends"></mat-icon>
			<ng-container *ngIf="!checkIfEndDateHasCompleted() else notpast">
				<span class="timer-title" translate>auction.timer.endsin</span>
				<span class="timer-title">&nbsp;{{ remainingTime.days() }}&nbsp;{{'auction.timer.days' | translate}}&nbsp;{{ remainingTime.hours() }}&nbsp;{{'auction.timer.hours' | translate}}&nbsp;{{ remainingTime.minutes() }}&nbsp;{{'auction.timer.minutes' | translate}}</span>
				<span class="timer-title">&nbsp;{{'-' + (auctionOffer.weight |copoNumber:'weight':(unitBatchOptions['to'].symbol ))}}&nbsp;{{'auction.timer.weight.available' | translate}}</span>
			</ng-container>
			<ng-template #notpast>
				<span class="timer-title" translate>auction.ended</span>
			</ng-template>
		</div>
	</div>
	<div class="offer-details-block">
		<div class="offer-details-block-item">
			<copo-stepper class="copo-stepper-container" [steps]="steps" (stepClicked)="onStepClicked($event)"></copo-stepper>
			<div class="copo-section-header" translate>auction.description</div>
			<div class="copo-grid-row-column" #soldToDiv>
				<mat-form-field floatLabel="always">
					<mat-label class="corporate-name" translate>guarantee.customer.name</mat-label>
					<mat-select (selectionChange)="soldToChanged($event)" [value]="defaultSoldTo"
						required>
						<mat-option *ngFor="let corporate of soldTos" [value]="corporate.businessId">
							{{corporate.name}}
						</mat-option>
					</mat-select>
					<mat-error *ngIf="defaultSoldTo">
						<span translate>guarantee.corporate.name.mandatory</span>
					</mat-error>
				</mat-form-field>
			</div>
			<div class="card-info-block">
				<div class="card-content-block triple-column">
					<div class="card-contents-infos">
						<div class="card-content-info">
							<div class="card-content-label" translate>offers.create.details.field.offer-name</div>
							<div class="card-content-value">{{ auctionOffer.name ? auctionOffer.name : UNDERSCORE}}</div>
						</div>
						<div class="card-content-info">
							<div class="card-content-label" translate>start.date</div>
							<div class="card-content-value">{{ auctionOffer.startDate ? (auctionOffer.startDate | copoDate:'datetime') : UNDERSCORE }}</div>
						</div>
						<div class="card-content-info">
							<div class="card-content-label" translate>auction.offer.payment.condition</div>
							<div class="card-content-value field-overflow">{{ auctionOffer.paymentTerm ? auctionOffer.paymentTerm : UNDERSCORE}}</div>
						</div>
					</div>
					<div class="card-contents-infos">
						<div class="card-content-info">
							<div class="card-content-label" translate>auction.mill</div>
							<div class="card-content-value">{{ auctionOffer.mill ? auctionOffer.mill.name : UNDERSCORE }}</div>
						</div>
						<div class="card-content-info">
							<div class="card-content-label" translate>end.date</div>
							<div class="card-content-value">{{ auctionOffer.endDate ? (auctionOffer.endDate | copoDate:'datetime') : UNDERSCORE }}</div>
						</div>
						<div class="card-content-info">
							<div class="card-content-label" translate>auction.offer.invoicing.in</div>
							<div class="card-content-value">{{ auctionOffer.invoicingUnit ? auctionOffer.invoicingUnit : UNDERSCORE}}</div>
						</div>
					</div>
					<div class="card-contents-infos">
						<div class="card-content-info">
							<div class="card-content-label" translate>auction.market</div>
							<div class="card-content-value">{{ auctionOffer.market ? auctionOffer.market : UNDERSCORE}}</div>
						</div>
						<div class="card-content-info">
							<div class="card-content-label" translate>auction.offer.lanned.loading.date</div>
							<div class="card-content-value">{{ auctionOffer.plannedLoadingDate ? (auctionOffer.plannedLoadingDate | copoDate:'date') : UNDERSCORE }}</div>
						</div>
						<div class="card-content-info">
							<div class="card-content-label" translate>auction.offer.transport.invoiced.conditions</div>
							<div class="card-content-value">{{ auctionOffer.transportInvoicingCondition ? auctionOffer.transportInvoicingCondition : UNDERSCORE}}</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<ng-container *ngIf="!isShipToLoading else spinner1">
			<ng-container *ngFor=" let bundle of auctionOffer.bundles; let i = index ;">
				<div class="bundle-list-block request-block-normal" #bundleDiv>
					<div class="bundle-list-block-item">
						<div class="bundle-list-block-row1"> 
							<div class="bundle-content-info">
								<div class="bundle-heading" translate>auction.offer.bundle
									<span>({{ bundle.numberOfProducts }}&nbsp;</span>
									<span translate>eoffer.product.plural</span>
									<span>)</span>
								</div>
								<div class="bundle-name">{{ bundle.name }}</div>
							</div>
							<mat-form-field [hideRequiredMarker]="true" class="card-container-column delivery-address-width" floatLabel="always">
								<mat-label class="card-header-label field-width" translate>datacenter-filter.delivery-address</mat-label>
								<mat-select class="copo-form-field" [value]="bundleFormArray.controls[i].controls.deliveryAddress.value" [formControl]="bundleFormArray.controls[i].controls.deliveryAddress" (selectionChange)="onDeliveryAddressChange(i)">
									<mat-option *ngFor="let shipto of shiptoList" [value]="shipto.businessId">
										{{ shipto.name }}
									</mat-option>
								</mat-select>
								<mat-error *ngIf="bundleFormArray.controls[i].controls.deliveryAddress.hasError('required')">
									<span translate>auction.offer.delivery.address.mandatory</span>
								</mat-error>
							</mat-form-field>
							<mat-form-field [hideRequiredMarker]="true" class="card-container-column transport-mode-width" floatLabel="always">
								<mat-label class="card-header-label field-width" translate>commercial-documents.transport-mode</mat-label>
								<mat-select class="copo-form-field" [value]="bundleFormArray.controls[i].controls.transportMode.value" [formControl]="bundleFormArray.controls[i].controls.transportMode"
									(selectionChange)="onTransportModeChange(i)">
									<mat-option *ngFor="let tmode of getTransportModeOptions(bundleFormArray.controls[i].controls.deliveryAddress.value!,
									this.auctionOffer.bundles[i].mill.pp39)" [value]="tmode.description">
										{{ tmode.name | translate }}
									</mat-option>
								</mat-select>
								<mat-error *ngIf="!checkIsDeliveryAddressFilled(i) && bundleFormArray.controls[i].controls.transportMode.hasError('required')">
									<span translate>auction.offer.tmode.mandatory</span>
								</mat-error>
							</mat-form-field>
							<mat-form-field [hideRequiredMarker]="true" class="card-container-column type-maritime-width" floatLabel="always">
								<mat-label class="card-header-label field-width" translate>auction.offer.type.of.maritime.transport</mat-label>
								<mat-select class="copo-form-field" [formControl]="bundleFormArray.controls[i].controls.typeOfMaritimeTransport">
								</mat-select>
							</mat-form-field>
							<div class="bundle-content-info" *ngIf="!incoterms2.get(i)">
								<div class="card-content-label" translate>order.incoterm</div>
								<div class="card-content-value">{{ incoterms1.get(i)? ('incoterm.'+incoterms1.get(i) | translate) : UNDERSCORE}}</div>
							</div>
							<div class="bundle-content-info" *ngIf="incoterms2.get(i)">
								<div class="card-content-label">
									<span translate>order.incoterm</span>
									<span>{{ '('+('order.incoterm2' | translate)+')' }}</span>
								</div>
								<div class="card-content-value">
									<span>{{ incoterms1.get(i)? ('incoterm.'+incoterms1.get(i) | translate) : UNDERSCORE}}</span>
									<span>{{ incoterms2.get(i)? ('('+incoterms2.get(i)+')') : UNDERSCORE}}</span>
								</div>
							</div>
							<a class="clear-infos-button" (click)="$event.preventDefault();resetForm(i)" href="#">
								<mat-icon class="customize-view-button-icon" svgIcon="icon_restore"></mat-icon>
								<span class="clear-infos-label" translate>auction.offer.clear.infos</span>
							</a>
						</div>
						<div class="bundle-list-block-row2">
							<div class="pill request-block-status">
								<div class="request-block-status-label">
									<span>{{ bundle.weight |copoNumber:'weight':(unitBatchOptions['to'].symbol )}}</span>
									<span>&nbsp;{{ UNDERSCORE }}&nbsp;</span>
									<span translate>auction.weight.unit.gross</span>
								</div>
							</div>
							<mat-form-field [hideRequiredMarker]="true" class="card-container-column step-product-spec-field field-padding-custref" floatLabel="always">
								<mat-label class="card-header-label field-width" translate>auction.offer.customer.reference</mat-label>
								<input matInput class="input-field-text field-width" [value]="bundleFormArray.controls[i].controls.customerReference.value" [formControl]="bundleFormArray.controls[i].controls.customerReference">
								<mat-icon class="pencil-icon pencil-icon-white" svgIcon="copo_pencil" matSuffix></mat-icon>
								<mat-error *ngIf="!checkIsDeliveryAddressFilled(i) && bundleFormArray.controls[i].controls.customerReference.hasError('required')">
									<span translate>auction.offer.customerref.mandatory</span>
								</mat-error>
							</mat-form-field>
							<mat-form-field [hideRequiredMarker]="true" class="card-container-column step-product-spec-field field-padding-exwprice" floatLabel="always">
								<mat-label class="card-header-label field-width" translate>auction.offer.exw.price</mat-label>
								<input 
									step="any"
									type="number"
									min="0"
									matInput
									spellcheck="false"
									autocomplete="off" 
									class="input-field-text field-width" 
									[value]="bundleFormArray.controls[i].controls.exwPrice.value" 
									[formControl]="bundleFormArray.controls[i].controls.exwPrice" 
									(change)="onExwPriceChange($event, i)">
								<mat-icon class="pencil-icon pencil-icon-white" svgIcon="copo_pencil" matSuffix></mat-icon>
								<mat-error *ngIf="!checkIsDeliveryAddressFilled(i) && bundleFormArray.controls[i].controls.exwPrice.hasError('required')">
									<span translate>auction.offer.exwprice.mandatory</span>
								</mat-error>
							</mat-form-field>
							<div class="bundle-content-info">
								<div class="card-content-label" translate>auction.offer.transport.cost</div>
								<div *ngIf="!transportCosts.get(i); else transportCostdisplay" class="card-content-value">{{ UNDERSCORE }}</div>
								<ng-template #transportCostdisplay>
									<div *ngIf="transportCosts.get(i)?.returncode==='0'" class="card-content-value">{{ getTransportCostAsNumber(i) || getTransportCostAsNumber(i) === 0 ? (getTransportCostAsNumber(i) | copoNumber: 'amount')+' '+('auction.price.unit.et' | translate) : UNDERSCORE }}</div>
									<div *ngIf="transportCosts.get(i)?.returncode!=='0'" class="card-content-value" translate>error.inavlid.transport.cost</div>
								</ng-template>
							</div>
							<div class="bundle-content-info">
								<div class="card-content-label" translate>auction.offer.effective.price</div>
								<div class="card-content-value">{{ effectiveprices.get(i) ? ((effectiveprices.get(i) | copoNumber: 'amount')+' '+('auction.price.unit.et' | translate)): UNDERSCORE }}</div>
							</div>
						<button *ngIf="!materialPanelExpandedmap.get(bundle.id)" type="button" mat-button class="expand-button" (click)="expandMaterialPanel(bundle.id)">
							<mat-icon svgIcon="md:chevron_right" class="expand-icon-down" color="accent"></mat-icon>
						</button>
					</div>
					<mat-expansion-panel class="material-block" [expanded]="materialPanelExpandedmap.get(bundle.id)" hideToggle="true">
						<div class="bundle-heading" translate>auction-material.details</div>
						<ng-container *ngFor=" let material of bundle.material">
							<div class="material-item">
								<div class="material-item-info">
									<div class="material-item-info-label label-value-weighted" translate>commercial-documents.steel-grade</div>
									<div class="material-item-info-value label-value-weighted text-uppercase">{{ material.material.steelgradeCommercialDescription }}</div>
								</div>
								<div class="material-item-info">
									<div class="material-item-info-label label-value-weighted" translate>batch.gross-t</div>
									<div class="material-item-info-value label-value-weighted">{{ material.material.weight | copoNumber:'weight'}}</div>
								</div>
								<div class="material-item-info">
									<div class="material-item-info-label" translate>eorder.wizard.product.thickness</div>
									<div class="material-item-info-value">{{ (material.material.thickness| copoNumber:'thickness':'mm') }}</div>
								</div>
								<div class="material-item-info">
									<div class="material-item-info-label" translate>eorder.wizard.product.width</div>
									<div class="material-item-info-value">{{ (material.material.width| copoNumber:'width':'mm') }}</div>
								</div>
								<div class="material-item-info">
									<div class="material-item-info-label" translate>auction-material.oil.type</div>
									<div class="material-item-info-value text-uppercase">{{ material.material.oilTypeDescription }}</div>
								</div>
								<div class="material-item-info">
									<div class="material-item-info-label" translate>datacenter-filter.form</div>
									<div class="material-item-info-value text-uppercase">{{ material.material.formDescription }}</div>
								</div>
								<div class="material-item-info">
									<div class="material-item-info-label" translate>auction-material.category.subcategory</div>
									<div class="material-item-info-value text-uppercase">{{ material.material.family + '/' + material.material.subFamily }}</div>
								</div>
								<div class="material-item-info">
									<div class="material-item-info-label" translate>order.coating</div>
									<div class="material-item-info-value text-uppercase">{{ material.material.coating }}</div>
								</div>
								<div class="material-item-info">
									<div class="material-item-info-label" translate>auction-material.downgrading.reason</div>
									<div class="material-item-info-value text-uppercase">{{ material.material.defect1Description }}</div>
								</div>
								<button type="button" mat-mini-fab color="link" class="view-request-icon">
									<mat-icon svgIcon="md:eye" color="accent"></mat-icon>
								</button>
							</div>
						</ng-container>
						<mat-divider class="margin-expansion-panel"></mat-divider>
						<mat-action-row>
							<button type="button" mat-button class="expand-button" (click)="shrinkMaterialPanel(bundle.id)">
								<mat-icon svgIcon="md:chevron_right" class="expand-icon-up" color="accent"></mat-icon>
							</button>
						</mat-action-row>
					</mat-expansion-panel>
					</div>
				</div>
				<div class="bundle-list-block request-block-small">
					<div class="bundle-list-block-item">
						<div class="bundle-list-block-row1"> 
							<div class="bundle-content-info">
								<div class="bundle-heading" translate>auction.offer.bundle
									<span>({{ bundle.numberOfProducts }}&nbsp;</span>
									<span translate>eoffer.product.plural</span>
									<span>)</span>
								</div>
							</div>
							<div class="bundle-name">{{ bundle.name }}</div>
							<div class="pill request-block-status">
								<div class="request-block-status-label">
									<span>{{ bundle.weight |copoNumber:'weight':(unitBatchOptions['to'].symbol )}}</span>
									<span>&nbsp;{{ UNDERSCORE }}&nbsp;</span>
									<span translate>auction.weight.unit.gross</span>
								</div>
							</div>
						</div>
						<div class="bundle-list-block-row2">
							<mat-form-field [hideRequiredMarker]="true" class="card-container-column delivery-address-width" floatLabel="always">
								<mat-label class="card-header-label field-width" translate>datacenter-filter.delivery-address</mat-label>
								<mat-select class="copo-form-field" [value]="bundleFormArray.controls[i].controls.deliveryAddress.value" [formControl]="bundleFormArray.controls[i].controls.deliveryAddress" (selectionChange)="onDeliveryAddressChange(i)">
									<mat-option *ngFor="let shipto of shiptoList" [value]="shipto.businessId">
										{{ shipto.name }}
									</mat-option>
								</mat-select>
							</mat-form-field>
							<mat-form-field [hideRequiredMarker]="true" class="card-container-column transport-mode-width" floatLabel="always">
								<mat-label class="card-header-label field-width" translate>commercial-documents.transport-mode</mat-label>
								<mat-select class="copo-form-field" [value]="bundleFormArray.controls[i].controls.transportMode.value" 
									[formControl]="bundleFormArray.controls[i].controls.transportMode" (selectionChange)="onTransportModeChange(i)">
									<mat-option *ngFor="let tmode of getTransportModeOptions(bundleFormArray.controls[i].controls.deliveryAddress.value!,
									this.auctionOffer.bundles[i].mill.pp39)" [value]="tmode.description">
										{{ tmode.name | translate }}
									</mat-option>
								</mat-select>
								<mat-error *ngIf="!checkIsDeliveryAddressFilled(i) && bundleFormArray.controls[i].controls.transportMode.hasError('required')">
									<span translate>auction.offer.tmode.mandatory</span>
								</mat-error>
							</mat-form-field>
							<mat-form-field [hideRequiredMarker]="true" class="card-container-column type-maritime-width" floatLabel="always">
								<mat-label class="card-header-label field-width" translate>auction.offer.type.of.maritime.transport</mat-label>
								<mat-select class="copo-form-field" [formControl]="bundleFormArray.controls[i].controls.typeOfMaritimeTransport">
								</mat-select>
							</mat-form-field>
							<mat-form-field [hideRequiredMarker]="true" class="card-container-column step-product-spec-field field-padding-custref" floatLabel="always">
								<mat-label class="card-header-label field-width" translate>auction.offer.customer.reference</mat-label>
								<input matInput class="input-field-text field-width" [value]="bundleFormArray.controls[i].controls.customerReference.value" [formControl]="bundleFormArray.controls[i].controls.customerReference">
								<mat-icon class="pencil-icon pencil-icon-white" svgIcon="copo_pencil" matSuffix></mat-icon>
								<mat-error *ngIf="!checkIsDeliveryAddressFilled(i) && bundleFormArray.controls[i].controls.customerReference.hasError('required')">
									<span translate>auction.offer.customerref.mandatory</span>
								</mat-error>
							</mat-form-field>
							<mat-form-field [hideRequiredMarker]="true" class="card-container-column step-product-spec-field field-padding-exwprice" floatLabel="always">
								<mat-label class="card-header-label field-width" translate>auction.offer.exw.price</mat-label>
								<input
									step="any"
									type="number"
									min="0"
									matInput
									spellcheck="false"
									autocomplete="off" 
									class="input-field-text field-width" 
									[value]="bundleFormArray.controls[i].controls.exwPrice.value" 
									[formControl]="bundleFormArray.controls[i].controls.exwPrice" 
									(change)="onExwPriceChange($event, i)">
								<mat-icon class="pencil-icon pencil-icon-white" svgIcon="copo_pencil" matSuffix></mat-icon>
								<mat-error *ngIf="!checkIsDeliveryAddressFilled(i) && bundleFormArray.controls[i].controls.exwPrice.hasError('required')">
									<span translate>auction.offer.exwprice.mandatory</span>
								</mat-error>
							</mat-form-field>
							<div class="bundle-content-info">
								<div class="card-content-label" translate>auction.offer.transport.cost</div>
								<div *ngIf="!transportCosts.get(i); else transportCostdisplay" class="card-content-value">{{ UNDERSCORE }}</div>
								<ng-template #transportCostdisplay>
									<div *ngIf="transportCosts.get(i)?.returncode==='0'" class="card-content-value">{{ getTransportCostAsNumber(i) || getTransportCostAsNumber(i) === 0  ? (getTransportCostAsNumber(i) | copoNumber: 'amount')+' '+('auction.price.unit.et' | translate) : UNDERSCORE }}</div>
									<div *ngIf="transportCosts.get(i)?.returncode!=='0'" class="card-content-value" translate>invalid.transport.price</div>
								</ng-template>
							</div>
							<div class="bundle-content-info">
								<div class="card-content-label" translate>auction.offer.effective.price</div>
								<div class="card-content-value">{{ effectiveprices.get(i) ? ((effectiveprices.get(i) | copoNumber: 'amount')+' '+('auction.price.unit.et' | translate)): UNDERSCORE }}</div>
							</div>
							<div class="bundle-content-info" *ngIf="!incoterms2.get(i)">
								<div class="card-content-label" translate>order.incoterm</div>
								<div class="card-content-value">{{ incoterms1.get(i)? ('incoterm.'+incoterms1.get(i) | translate) : UNDERSCORE}}</div>
							</div>
							<div class="bundle-content-info" *ngIf="incoterms2.get(i)">
								<div class="card-content-label">
									<span translate>order.incoterm</span>
									<span>{{ '('+('order.incoterm2' | translate)+')' }}</span>
								</div>
								<div class="card-content-value">
									<span>{{ incoterms1.get(i)? ('incoterm.'+incoterms1.get(i) | translate) : UNDERSCORE}}</span>
									<span>{{ incoterms2.get(i)? ('('+incoterms2.get(i)+')') : UNDERSCORE}}</span>
								</div>
							</div>
						</div>
						<div class="bundle-list-block-row3">
							<a class="clear-infos-button" (click)="$event.preventDefault();resetForm(i)" href="#">
								<mat-icon class="customize-view-button-icon" svgIcon="icon_restore"></mat-icon>
								<span class="clear-infos-label" translate>auction.offer.clear.infos</span>
							</a>
						</div>
					<div class="bundle-list-block-row3">
						<button *ngIf="!materialPanelExpandedmap.get(bundle.id)" type="button" mat-button class="expand-button" (click)="expandMaterialPanel(bundle.id)">
							<mat-icon svgIcon="md:chevron_right" class="expand-icon-down" color="accent"></mat-icon>
						</button>
					</div>
					<mat-expansion-panel class="material-block" [expanded]="materialPanelExpandedmap.get(bundle.id)" hideToggle="true">
						<div class="bundle-heading" translate>auction-material.details</div>
						<ng-container *ngFor=" let material of bundle.material">
							<div class="material-item">
								<div class="material-item-info">
									<div class="material-item-info-label label-value-weighted">Steel grade</div>
									<div class="material-item-info-value label-value-weighted text-uppercase">{{ material.material.steelgradeCommercialDescription }}</div>
								</div>
								<div class="material-item-info">
									<div class="material-item-info-label label-value-weighted">Gross weight(t)</div>
									<div class="material-item-info-value label-value-weighted">{{ material.material.weight | copoNumber:'weight' }}</div>
								</div>
								<div class="material-item-info">
									<div class="material-item-info-label">Thickness</div>
									<div class="material-item-info-value">{{ (material.material.thickness| copoNumber:'thickness':'mm') }}</div>
								</div>
								<div class="material-item-info">
									<div class="material-item-info-label">Width</div>
									<div class="material-item-info-value">{{ (material.material.width| copoNumber:'width':'mm') }}</div>
								</div>
								<div class="material-item-info">
									<div class="material-item-info-label">Oil type</div>
									<div class="material-item-info-value text-uppercase">{{ material.material.oilTypeDescription }}</div>
								</div>
								<div class="material-item-info">
									<div class="material-item-info-label">Form</div>
									<div class="material-item-info-value text-uppercase">{{ material.material.formDescription }}</div>
								</div>
								<div class="material-item-info">
									<div class="material-item-info-label">Cat/sub</div>
									<div class="material-item-info-value text-uppercase">{{ material.material.family + '/' + material.material.subFamily }}</div>
								</div>
								<div class="material-item-info">
									<div class="material-item-info-label">Coating</div>
									<div class="material-item-info-value text-uppercase">{{ material.material.coating }}</div>
								</div>
								<div class="material-item-info">
									<div class="material-item-info-label">Down grading reason</div>
									<div class="material-item-info-value text-uppercase">{{ material.material.defect1Description }}</div>
								</div>
								<button type="button" mat-mini-fab color="link" class="view-request-icon">
									<mat-icon svgIcon="md:eye" color="accent"></mat-icon>
								</button>
							</div>
						</ng-container>
						<mat-divider class="margin-expansion-panel"></mat-divider>
						<mat-action-row>
							<button type="button" mat-button class="expand-button" (click)="shrinkMaterialPanel(bundle.id)">
								<mat-icon svgIcon="md:chevron_right" class="expand-icon-up" color="accent"></mat-icon>
							</button>
						</mat-action-row>
					</mat-expansion-panel>
					</div>
				</div>
			</ng-container>
		</ng-container>
		<ng-template #spinner1>
			<copo-loading-spinner class="loading-spinner-container-padded"></copo-loading-spinner>
		</ng-template>
	</div>
</div>
<ng-template #spinner>
	<copo-loading-spinner class="loading-spinner-container-padded"></copo-loading-spinner>
</ng-template>